<div class="d-flex">
  <div class="flex-grow-1">
    <div class="d-flex justify-content-between">
      <h2>Markup Settings</h2>
      <button
        mat-flat-button
        color="primary"
        i18n="@@office-setting.new-profit-setting"
        aria-label="New markup settings"
        class="office-settings-action-button"
        (click)="onClickCreateSetting()"
      >
        New markup settings
      </button>
    </div>
    <input id="search" matInput placeholder="Search" />
    <div class="d-flex flex-column" style="gap: 20px">
      @for (
        rateMarkupSetting of $any(rateMarkupSettings) | paginate: config;
        track rateMarkupSetting
      ) {
        <article
          class="markup-setting-card"
          [class.expanded]="rateMarkupSetting.expanded"
        >
          <div
            class="d-flex justify-content-between align-items-center"
            (click)="onExpandMarkupSetting(rateMarkupSetting)"
          >
            <div class="d-flex" style="gap: 14px">
              @if (rateMarkupSetting.expanded) {
                <div class="d-flex" style="margin-right: -10px">
                  <button
                    class="office-settings-icon-button"
                    mat-icon-button
                    color="primary"
                    aria-label="Edit rate markup setting"
                    (click)="onClickEditSetting(rateMarkupSetting, $event)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    class="office-settings-icon-button"
                    mat-icon-button
                    color="primary"
                    aria-label="Delete rate markup setting"
                    (click)="openDeleteSettingModal(rateMarkupSetting, $event)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
              @if (rateMarkupSetting.expanded) {
                <div style="border-left: 1px solid #7e47c533"></div>
              }
              <div class="d-flex flex-column">
                <h3>{{ rateMarkupSetting.name }}</h3>
                <span class="records-count"
                  >{{ rateMarkupSetting.rateMarkupCount }} records</span
                >
              </div>
            </div>
            @if (!rateMarkupSetting.expanded) {
              <i class="fa fa-chevron-down"></i>
            }
            @if (rateMarkupSetting.expanded) {
              <i class="fa fa-chevron-up"></i>
            }
          </div>
          @if (rateMarkupSetting.expanded) {
            <div class="mt-3">
              <div class="d-flex mb-3" style="gap: 10px">
                <button
                  mat-flat-button
                  color="secondary"
                  aria-label="Create record"
                  class="office-settings-action-button"
                  (click)="onClickCreateMarkupRecord(rateMarkupSetting)"
                >
                  <i class="fa fa-plus me-2"></i>
                  <span i18n="@@office-settings.create-record"
                    >Create record</span
                  >
                </button>
              </div>
              @if (rateMarkupSetting.rateMarkups) {
                <table class="markup-setting-records">
                  <thead>
                    <tr>
                      <th id="col-min-charge">Min. charge</th>
                      <th id="col-weight-break">Weight break</th>
                      <th id="col-applies-to">Condition</th>
                      <th id="col-actions"></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      rateMarkup of rateMarkupSetting.rateMarkups;
                      track rateMarkup
                    ) {
                      <tr
                        (click)="viewRateMarkup(rateMarkupSetting, rateMarkup)"
                      >
                        <td headers="col-min-charge">
                          <div>
                            {{ rateMarkup.markupBrackets[0].markupAmount }}
                            {{
                              rateMarkup.markupBrackets[0].isMarkupPercent
                                ? "%"
                                : rateMarkup.markupCurrency.currencyCode
                            }}
                          </div>
                        </td>
                        <td headers="col-weight-break">
                          @if (
                            rateMarkup.applyToAllWeightBreaks && !isAsideOpen
                          ) {
                            <div>
                              All weight breaks -
                              {{ rateMarkup.markupBrackets[1].markupAmount }}
                              {{
                                rateMarkup.markupBrackets[1].isMarkupPercent
                                  ? "%"
                                  : rateMarkup.markupCurrency.currencyCode +
                                    "/KG"
                              }}
                            </div>
                          }
                          @if (
                            rateMarkup.applyToAllWeightBreaks && isAsideOpen
                          ) {
                            <div>
                              {{ rateMarkup.markupBrackets[1].markupAmount }}
                              {{
                                rateMarkup.markupBrackets[1].isMarkupPercent
                                  ? "%"
                                  : rateMarkup.markupCurrency.currencyCode +
                                    "/KG"
                              }}
                            </div>
                          }
                          @if (
                            !rateMarkup.applyToAllWeightBreaks && !isAsideOpen
                          ) {
                            <div>Custom per weight break</div>
                          }
                          @if (
                            !rateMarkup.applyToAllWeightBreaks && isAsideOpen
                          ) {
                            <div>Custom</div>
                          }
                        </td>
                        <td headers="col-applies-to">
                          <div
                            class="d-flex flex-wrap align-items-center"
                            style="gap: 6px"
                          >
                            @if (
                              (rateMarkup.onlyAirlines ?? []).length === 0 &&
                              (rateMarkup.onlyCommodities ?? []).length === 0 &&
                              (rateMarkup.onlyDestinationAirports ?? [])
                                .length === 0 &&
                              (rateMarkup.notAirlines ?? []).length === 0 &&
                              (rateMarkup.notCommodities ?? []).length === 0 &&
                              (rateMarkup.notDestinationAirports ?? [])
                                .length === 0
                            ) {
                              <div>-</div>
                            }
                            @if (isMarkupApplyTo(rateMarkup)) {
                              <span>Apply To</span>
                            }
                            @if (isMarkupExclude(rateMarkup)) {
                              <span>Exclude</span>
                            }
                            @if (
                              rateMarkup.onlyAirlines?.length > 0 ||
                              rateMarkup.notAirlines?.length > 0
                            ) {
                              <div class="condition-count">
                                <span>Airline</span>
                                @if (!isAsideOpen) {
                                  <span class="count">{{
                                    rateMarkup.onlyAirlines.length ||
                                      rateMarkup.notAirlines.length
                                  }}</span>
                                }
                              </div>
                            }
                            @if (
                              rateMarkup.onlyCommodities?.length > 0 ||
                              rateMarkup.notCommodities?.length > 0
                            ) {
                              <div class="condition-count">
                                <span>Commodity</span>
                                @if (!isAsideOpen) {
                                  <span class="count">{{
                                    rateMarkup.onlyCommodities.length ||
                                      rateMarkup.notCommodities.length
                                  }}</span>
                                }
                              </div>
                            }
                            @if (
                              rateMarkup.onlyDestinationAirports?.length > 0 ||
                              rateMarkup.notDestinationAirports?.length > 0
                            ) {
                              <div class="condition-count">
                                <span>Dest.</span>
                                @if (!isAsideOpen) {
                                  <span class="count">{{
                                    rateMarkup.onlyDestinationAirports.length ||
                                      rateMarkup.notDestinationAirports.length
                                  }}</span>
                                }
                              </div>
                            }
                          </div>
                        </td>
                        <td headers="col-actions">
                          <div class="d-flex">
                            <button
                              class="office-settings-icon-button"
                              mat-icon-button
                              color="primary"
                              aria-label="Duplicate rate markup"
                              (click)="
                                onClickDuplicateMarkup(
                                  rateMarkup,
                                  $event,
                                  rateMarkupSetting
                                )
                              "
                            >
                              <mat-icon>content_copy</mat-icon>
                            </button>
                            <button
                              class="office-settings-icon-button"
                              mat-icon-button
                              color="primary"
                              aria-label="Edit rate markup"
                              (click)="
                                onClickEditMarkup(
                                  rateMarkup,
                                  $event,
                                  rateMarkupSetting
                                )
                              "
                            >
                              <mat-icon>edit</mat-icon>
                            </button>
                            <button
                              class="office-settings-icon-button"
                              mat-icon-button
                              color="primary"
                              aria-label="Delete rate markup"
                              (click)="
                                openDeleteRecordModal(
                                  rateMarkup,
                                  $event,
                                  rateMarkupSetting
                                )
                              "
                            >
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </div>
          }
        </article>
      }
      <pagination-controls
        previousLabel="&lt;"
        nextLabel="&gt;"
        (pageChange)="onPageChange($event)"
      ></pagination-controls>
    </div>
  </div>

  <aside
    #rightSideNav
    id="rate-markup-aside"
    [class.expanded]="asideContent"
    cdkScrollable
  >
    <div
      id="view-markup"
      [class.show]="asideContent === 'view-markup' && selectedMarkup()"
    >
      <div class="d-flex justify-content-between mb-4">
        <button class="close" (click)="asideContent = undefined">
          <i class="fa-solid fa-x"></i>
        </button>
        <div class="d-flex" style="gap: 12px">
          <button
            mat-flat-button
            color="secondary"
            i18n="@@global.edit"
            aria-label="Edit"
            class="office-settings-action-button"
            (click)="onClickEditMarkup(selectedMarkup(), $event)"
          >
            Edit
          </button>
          <button
            mat-flat-button
            color="secondary"
            i18n="@@global.delete"
            aria-label="Delete"
            class="office-settings-action-button"
            (click)="openDeleteRecordModal(selectedMarkup(), $event)"
          >
            Delete
          </button>
        </div>
      </div>
      <h3>View Record</h3>
      <div class="d-flex justify-content-between">
        <span style="color: #858585">Weight break type</span>
        @if (selectedMarkup()?.applyToAllWeightBreaks) {
          <span style="font-weight: 400">All weight breaks</span>
        }
        @if (!selectedMarkup()?.applyToAllWeightBreaks) {
          <span style="font-weight: 400">Custom per weight break</span>
        }
      </div>
      <div class="divider">
        <h4>Margin</h4>
        <div></div>
      </div>
      <div class="margin-table">
        <table>
          <thead>
            <tr>
              <th id="col-weight-break">WEIGHT BREAK</th>
              <th id="col-margin">MARKUP</th>
            </tr>
          </thead>
          <tbody>
            @for (
              markupBracket of selectedMarkup()?.markupBrackets;
              track markupBracket
            ) {
              <tr
                [class.d-none]="
                  markupBracket.weightType.weightType === 'KG' &&
                  selectedMarkup()?.applyToAllWeightBreaks
                "
              >
                <td headers="col-weight-break">
                  {{
                    weightTypeLabel(
                      markupBracket.weightType,
                      selectedMarkup()?.applyToAllWeightBreaks
                    )
                  }}
                </td>
                <td headers="col-margin">
                  {{ markupBracket.markupAmount }}
                  {{ amountSuffix(selectedMarkup(), markupBracket) }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="divider">
        <h4>Condition</h4>
        <div></div>
      </div>
      <article
        class="condition-groups mb-4"
        [class.expanded]="applyToExpanded()"
      >
        <div
          class="d-flex justify-content-between"
          (click)="applyToExpanded.set(!applyToExpanded())"
        >
          <h5>Apply to</h5>
          @if (!applyToExpanded()) {
            <span>V</span>
          }
          @if (applyToExpanded()) {
            <span>^</span>
          }
        </div>
        @if (applyToExpanded()) {
          <div class="d-flex flex-column" style="gap: 24px">
            <common-markup-condition-group
              label="Airline"
              [items]="selectedMarkupOnlyAirlines()"
            />
            <common-markup-condition-group
              label="Commodity"
              [items]="selectedMarkupOnlyCommodities()"
            />
            <common-markup-condition-group
              label="Destination"
              [items]="selectedMarkupOnlyDestinationAirports()"
            />
          </div>
        }
      </article>
      <article class="condition-groups" [class.expanded]="excludeExpanded()">
        <div
          class="d-flex justify-content-between"
          (click)="excludeExpanded.set(!excludeExpanded())"
        >
          <h5>Exclude</h5>
          @if (!excludeExpanded()) {
            <span>V</span>
          }
          @if (excludeExpanded()) {
            <span>^</span>
          }
        </div>
        @if (excludeExpanded()) {
          <div class="d-flex flex-column" style="gap: 24px">
            <common-markup-condition-group
              label="Airline"
              [items]="selectedMarkupNotAirlines()"
            />
            <common-markup-condition-group
              label="Commodity"
              [items]="selectedMarkupNotCommodities()"
            />
            <common-markup-condition-group
              label="Destination"
              [items]="selectedMarkupNotDestinationAirports()"
            />
          </div>
        }
      </article>
    </div>
    <form
      id="create-update-markup"
      class="office-settings-form"
      [class.show]="
        asideContent === 'create-markup' || asideContent === 'update-markup'
      "
      [formGroup]="markupForm"
    >
      <section class="body">
        <div class="d-flex align-items-start justify-content-between">
          @if (asideContent === "create-markup") {
            <h3>Create Record</h3>
          }
          @if (asideContent === "update-markup") {
            <h3>Edit Record</h3>
          }
          <button
            type="button"
            class="close"
            (click)="asideContent = undefined"
          >
            <i class="fa-solid fa-x"></i>
          </button>
        </div>
        @if (rateCurrencies?.length > 1) {
          <div class="form-field">
            <label>Markup currency</label>
            <mat-select
              formControlName="markupCurrencyCode"
              panelClass="office-settings-panel"
            >
              @for (currency of rateCurrencies; track currency) {
                <mat-option
                  class="office-settings-select-option"
                  [value]="currency"
                >
                  {{ currency }}
                </mat-option>
              }
            </mat-select>
          </div>
        }
        <div class="form-field">
          <label>Weight break type</label>
          <div class="radio-group">
            <div>
              <label for="per-weight-break">Custom per weight break</label>
              <input
                type="radio"
                formControlName="applyToAllWeightBreaks"
                id="per-weight-break"
                [value]="false"
              />
            </div>
            <div>
              <label for="all-weight-break">All weight breaks</label>
              <input
                type="radio"
                formControlName="applyToAllWeightBreaks"
                id="all-weight-break"
                [value]="true"
              />
            </div>
          </div>
        </div>
        <div class="divider">
          <h4>Margin</h4>
          <div></div>
        </div>
        <ng-container formArrayName="markupBrackets">
          @for (
            _ of [].constructor(markupBracketsArray.length);
            track _;
            let i = $index
          ) {
            <div
              class="form-field"
              [class.d-none]="
                defaultMarkupBrackets[i].weightType.weightType === 'KG' &&
                markupAllWeightControl.value
              "
              [formGroupName]="i"
            >
              <label class="required">{{
                weightTypeLabel(
                  defaultMarkupBrackets[i].weightType,
                  markupAllWeightControl.value
                )
              }}</label>
              <div class="markup">
                <input matInput formControlName="markupAmount" />
                <mat-select
                  formControlName="isMarkupPercent"
                  panelClass="office-settings-panel"
                >
                  <mat-option
                    class="office-settings-select-option"
                    [value]="true"
                  >
                    %
                  </mat-option>
                  <mat-option
                    class="office-settings-select-option"
                    [value]="false"
                  >
                    {{
                      defaultMarkupBrackets[i].weightType.weightType === "M"
                        ? markupCurrencyControl.value
                        : markupCurrencyControl.value + "/KG"
                    }}
                  </mat-option>
                </mat-select>
              </div>
              @if (
                markupBracketsArray.at(i).get("markupAmount").touched &&
                !markupBracketsArray.at(i).valid
              ) {
                <mat-error class="office-settings-error">
                  {{ bracketErrorMessage(markupBracketsArray.at(i)) }}
                </mat-error>
              }
            </div>
          }
        </ng-container>
        <div class="divider">
          <h4>Condition</h4>
          <div></div>
        </div>
        <div
          class="d-flex justify-content-between w-100"
          style="margin-bottom: 24px"
        >
          <label>Apply to</label>
          <div class="d-flex flex-column" style="gap: 16px">
            <common-markup-condition-chips
              [control]="$any(markupForm.controls['onlyAirlines'])"
              [options]="airlineOptions"
              placeholder="Airline"
            />
            <common-markup-condition-chips
              [control]="$any(markupForm.controls['onlyCommodities'])"
              [options]="commodityOptions"
              placeholder="Commodity"
            />
            <common-markup-condition-chips
              [control]="$any(markupForm.controls['onlyDestinationAirports'])"
              [options]="airportOptions"
              placeholder="Destination"
            />
          </div>
        </div>
        <div class="d-flex justify-content-between w-100">
          <label>Exclude</label>
          <div class="d-flex flex-column" style="gap: 16px">
            <common-markup-condition-chips
              [control]="$any(markupForm.controls['notAirlines'])"
              [options]="airlineOptions"
              placeholder="Airline"
            />
            <common-markup-condition-chips
              [control]="$any(markupForm.controls['notCommodities'])"
              [options]="commodityOptions"
              placeholder="Commodity"
            />
            <common-markup-condition-chips
              [control]="$any(markupForm.controls['notDestinationAirports'])"
              [options]="airportOptions"
              placeholder="Destination"
            />
          </div>
        </div>
      </section>
      <section class="footer">
        @if (asideContent === "create-markup") {
          <mat-checkbox formControlName="createAnother">
            Create another record
          </mat-checkbox>
        }
        @if (asideContent === "update-markup") {
          <div></div>
        }
        <div class="actions">
          <button
            mat-flat-button
            type="button"
            color="secondary"
            i18n="@@global.cancel"
            aria-label="Cancel"
            class="office-settings-action-button"
            (click)="asideContent = undefined"
          >
            Cancel
          </button>
          <button
            mat-flat-button
            type="submit"
            color="primary"
            i18n="@@global.create"
            aria-label="Create"
            class="office-settings-action-button"
            [disabled]="isSavingRecord || !markupForm.valid"
            (click)="onSaveEditMarkup()"
          >
            {{ asideContent === "update-markup" ? "Save changes" : "Create" }}
          </button>
        </div>
      </section>
    </form>
    <form
      id="create-update-setting"
      [class.show]="
        asideContent === 'create-setting' || asideContent === 'update-setting'
      "
      [formGroup]="markupSettingForm"
    >
      <section class="body">
        <div class="d-flex align-items-start justify-content-between">
          @if (asideContent === "create-setting") {
            <h3>Create Markup Setting</h3>
          }
          @if (asideContent === "update-setting") {
            <h3>Edit Markup Setting</h3>
          }
          <button
            type="button"
            class="close"
            (click)="asideContent = undefined"
          >
            <i class="fa-solid fa-x"></i>
          </button>
        </div>
        <div class="form-field">
          <label class="required">Name</label>
          <input matInput formControlName="name" />
        </div>
      </section>
      <section class="footer">
        <div></div>
        <div class="actions">
          <button
            mat-flat-button
            type="button"
            color="secondary"
            i18n="@@global.cancel"
            aria-label="Cancel"
            class="office-settings-action-button"
            (click)="asideContent = undefined"
          >
            Cancel
          </button>
          <button
            mat-flat-button
            type="submit"
            color="primary"
            i18n="@@global.create"
            aria-label="Create"
            class="office-settings-action-button"
            [disabled]="isSavingSetting || !markupSettingForm.valid"
            (click)="onSaveEditSetting()"
          >
            {{ asideContent === "update-setting" ? "Save changes" : "Next" }}
          </button>
        </div>
      </section>
    </form>
  </aside>
</div>

<ng-template #deleteModal let-modal>
  <div id="delete-modal-content">
    <h2>Are you sure?</h2>
    <p>{{ deleteModalMessage }}</p>
    <div class="d-flex" style="gap: 16px">
      <button
        mat-flat-button
        type="button"
        color="secondary"
        i18n="@@global.cancel"
        aria-label="Cancel"
        class="office-settings-action-button delete flex-grow-1"
        (click)="modal.dismiss()"
      >
        Cancel
      </button>
      <button
        mat-flat-button
        type="submit"
        color="primary"
        i18n="@@global.delete"
        aria-label="Delete"
        class="office-settings-action-button delete flex-grow-1"
        (click)="modal.close()"
      >
        Delete
      </button>
    </div>
  </div>
</ng-template>
